import { makeStyles } from '@material-ui/styles';
export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    height: '89vh',
    [theme.breakpoints.down('sm')]: {
      backgroundColor: theme.palette.white,
      overflowY: 'scroll',
      overflowX: 'hidden',
      justifyContent: 'flex-start',
    },
  },
  // grid: {
  //   gridTemplateRows: '4fr 8fr',
  //   height: '100%',
  //   padding: '10px 20px',
  // },

  messageContainer: {
    padding: '40px',
    display: 'grid',
    gridTemplateRows: '4fr 4fr 2fr 2fr',
    gridRowGap: '20px',
  },

  containerBox: {
    overflow: 'auto',
    maxHeight: '100%',
    borderRadius: '0 0 8px 8px',
  },

  titleBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    padding: '30px 40px',
  },

  formBox: {
    display: 'flex',
    flexDirection: 'column',
  },

  input: {
    marginTop: theme.spacing(3),
  },

  container: {
    boxShadow: 'inset 0 0 0em white, 0 0 2em #ccc;',
    width: '50%',
    maxWidth: '532px',
    height: '600px',
    borderRadius: '0.8rem',
    backgroundColor: theme.palette.white,
    [theme.breakpoints.down('sm')]: {
      width: '90%',
      borderRadius: '0.8rem',
      height: 'auto',
      marginTop: '15px',
    },
  },

  form: {
    backgroundColor: theme.palette.white,
    padding: '0 20px',
  },

  fieldGroup: {
    paddingBottom: theme.spacing(3),
  },

  footer: {
    textAlign: 'center',
  },

  title: {
    textAlign: 'center',
    color: '#707070',
    fontWeight: 500,
  },

  subtitle: {
    textAlign: 'center',
    color: '#707070',
  },

  center: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  sendButton: {
    margin: theme.spacing(2, 0),
  },

  backDiv: {
    width: '40%',
    margin: '20px 0px 0px 30px',
    fontSize: '14px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },

  backButton: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
}));